import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=62bc03d8&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=js&"
export * from "./DataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bc03d8",
  null
  
)

export default component.exports